var app = {
	header: {
		closeButton: "Sluiten",
		copyrightLabel: "Auteursrecht",
		helpLabel: "Help",
		legalNoticeLabel: "Juridische kennisgeving",
		logoutButton: "Uitloggen",
		menuLabel: "Menu",
		noUserDataLabel: "Geen gebruikersgegevens beschikbaar",
		notificationsLabel: "Meldingen",
		privacyPolicyLabel: "Privacybeleid",
		serviceAppLabel: "Service-App",
		settingsLabel: "Instellingen",
		shopLabel: "Shop",
		smartFactorySuiteLabel: "Smart-Factory Suite",
		userLabel: "Profiel",
		userProfileLinkText: "Gebruikersprofiel"
	}
};
var contentLoadingError = "Inhoud kan niet worden geladen";
var dashboard = {
	cancel: {
		button: "Annuleren"
	},
	edit: {
		button: "Bewerken"
	},
	reset: {
		button: "Resetten"
	},
	save: {
		button: "Opslaan"
	},
	share: {
		button: "Delen"
	}
};
var filter = {
	clear: "Filters wissen",
	clearAll: "Alle Filters wissen"
};
var locationMap = {
	locationLink: {
		label: "Ga naar de locatie"
	}
};
var machineDiscontinuation = {
	linkText: "Meer informatie"
};
var notifications = {
	button: {
		loadMore: "Meer laden"
	},
	date: {
		lastMonth: "Vorige maand",
		lastWeek: "Vorige week",
		older: "Ouder",
		thisMonth: "Deze maand",
		thisWeek: "Deze week",
		today: "Vandaag",
		yesterday: "Gisteren"
	},
	error: {
		general: "Momenteel kunnen er geen meldingen worden weergegeven. Probeer het later opnieuw.",
		unauthorized: "Meld u aan om meldingen te zien"
	},
	info: {
		activateSettings: "Om meldingen te ontvangen, schakel ze in de instellingen in",
		noNotification: "Er zijn momenteel geen berichten voor u."
	},
	title: "Meldingen"
};
var results = {
	counter: {
		label: "resultaten"
	}
};
var scrollToTop = {
	label: "Naar boven scrollen"
};
var slider = {
	nextButton: {
		label: "Volgende dia"
	},
	paginationBullet: {
		label: "Dia"
	},
	prevButton: {
		label: "Vorige dia"
	}
};
var sorting = {
	ascending: "Oplopend",
	descending: "Aflopend"
};
var userAccount = {
	address: {
		label: "Postadres"
	},
	email: {
		label: "E-mail"
	},
	language: {
		label: "Taal",
		locale: "Landinstelling",
		select: "Selecteer taal",
		settings: "Taalinstellingen"
	},
	loggedOut: {
		message: "U bent niet ingelogd"
	},
	login: {
		button: "Aanmelden"
	},
	name: {
		label: "Naam"
	},
	phone: {
		label: "Telefoon"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Filter machines",
			label: "Machines",
			option: {
				all: "Alle machines"
			},
			select: "Selecteer machine"
		},
		period: {
			label: "Periode",
			option: {
				currentMonth: "Deze maand",
				currentWeek: "Deze week",
				lastMonth: "Vorige maand",
				lastWeek: "Vorige week",
				today: "Vandaag",
				yesterday: "Gisteren"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Mijn widgets"
	},
	noDescriptionAvailable: "Geen beschrijving beschikbaar.",
	widget: {
		SampleMyMachines: {
			title: "Mijn machines"
		},
		SampleMyServiceCalls: {
			title: "Serviceoproepen"
		},
		SampleMyTrackingList: {
			title: "Volglijst"
		},
		SampleMyUserAccount: {
			title: "Mijn profiel"
		},
		SampleOperationalStatesChart: {
			title: "Operationele statussen"
		},
		SampleWidgetFilter: {
			title: "Filterinstellingen"
		},
		SampleWorkloadBalanceChart: {
			title: "Werklastbalans"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	filter: filter,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, filter, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
